import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';
import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class FormFieldsetLegend extends Component {
  render() {
    let className = cx({
      formFieldsetLegend: true,
    });

    return (
      <div className={classnames(className)}>
        <h4>{this.props.children}</h4>
      </div>
    );
  }
}
